import { GoBackButton } from "../atoms/buttons"

export const ScreenNavigation = ({title,goBack,content}) => {
    return (
        <div className="horizontal space-between">
            <div className='horizontal'>
            <GoBackButton
                    onClick={goBack}
                    title={""}
                    left={true}
                    className="back-button go-back-btn"
                    color={"grey-background-100 black-color semi-bold"}

                />
                <h5 className="standard-text-color">{title}</h5>
            </div>
            {content}
        </div>
    )
}
